import React, { Component } from 'react';
import { Stage, Layer, Image } from 'react-konva';
import AvatarGroup from './components/AvatarGroup/AvatarGroup';
//import TextGroup from './components/TextGroup/TextGroup'
import TextSolo from './components/TextGroup/TextSolo'
import Controls from './components/Controls/Controls';
import classes from './App.css';
// import backgrounds from './img/backgrounds/Backgrounds';
import gifts from './img/gifts/gifts';
import bg from './img/clothes/bg.png';
import body from './img/clothes/body.png';
import shoes from './img/clothes/shoes/shoes';
import pants from './img/clothes/pants/pants';
import shirt from './img/clothes/shirt/shirt';
import heads from './img/clothes/heads/heads';
import faces from './img/clothes/faces/faces';
import accessorius from './img/clothes/accessorius/accessorius';
import fonts from './UI/Fonts/Fonts';
//import styles from './UI/Styles/Styles';
import palette from './UI/Palette/Palette';
import ControlsToggle from './components/ControlsToggle/ControlsToggle';
import Gift from "./components/Gifts/Gift";
import * as Konva from "konva";
import FirstScreen from "./components/FirstScreen/FirstScreen";
// import car from './img/car.png'

//let textIndex = 0;

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      width: window.innerWidth > 860 ? 860 : window.innerWidth,
      // height: window.innerHeight,
      height: window.innerWidth > 860 ? 860 : window.innerWidth,
      textWidth: 300,
      textHeight: 50,
      background: null,
      textStyle: null,
      textColor: '#333',
      fontFamily: fonts[0],
      imgSide: 200,
      sideWidth: 200,
      sideHeight: 200,
      avatarPosition: null,
      zoomerSide: 40,
      showPalette: false,
      showGiftPalette:false,
      showControls: window.innerWidth > 768,
      gifts:[],
      texts:[],
      currentTextSet:{
        color: '#333',
        family: fonts[0],
        italic: false,
        bold: false,
        underline: false,
        size: 22,
        value: 'Текст',
        unit: null,
      },
      carOpacity: 1,
      carX: window.innerWidth > 1120 ? 1120 - 500 : window.innerWidth > 480 ? window.innerWidth - 200 : window.innerWidth - 150,
      carY: window.innerWidth > 1120 ? window.innerHeight - 328 : window.innerWidth > 480 ? window.innerHeight - 262 : window.innerHeight - 197,
      carWidth: window.innerWidth > 1120 ? 250 : window.innerWidth > 480 ? 200 : 150,
      carHeight: window.innerWidth > 1120 ? 328 : window.innerWidth > 480 ? 262 : 197,
      elementsIndex: 3,
      avatarZIndex: 10,
      photoHidden: false,
      shoes: {
        src: null,
        num: 0,
      },
      pants: {
        src: null,
        num: 0,
      },
      shirt: {
        src: null,
        num: 0,
      },
      heads: {
        src: null,
        num: 0,
      },
      faces: {
        src: null,
        num: 0,
      },
      accessorius: {
        src: null,
        num: 0,
      },
      bg: null,
      body: null,
      // showDeleteButton: false,
      firstScreenShown: true,
      token: (new URL(window.location)).searchParams.get('token'),
    }
  }
  currentBackground = 0;
  currentShoes = 0;
  currentPants = 0;
  currentShirt = 0;
  currentHeads = 0;
  currentFaces = 0;

  componentDidMount() {
    // const image = new window.Image();
    // image.src = backgrounds[0];
    // image.onload = () => {
    //   this.setState({
    //     background: image
    //   });
    // };
    const imageBG = new window.Image();
    imageBG.src = bg;
    imageBG.onload = () => {
      this.setState({
        bg: imageBG
      });
    };
    const imageBody = new window.Image();
    imageBody.src = body;
    imageBody.onload = () => {
      this.setState({
        body: imageBody
      });
    };
    const imageShoes = new window.Image();
    const firstShoes = shoes[Math.floor(Math.random() * shoes.length)];
    imageShoes.src = firstShoes.url;
    imageShoes.onload = () => {
      this.setState({
        shoes: {
          src: imageShoes,
          num: firstShoes.num,
        }
      });
    };
    const imagePants = new window.Image();
    const firstPants = pants[Math.floor(Math.random() * pants.length)];
    imagePants.src = firstPants.url;
    imagePants.onload = () => {
      this.setState({
        pants: {
          src: imagePants,
          num: firstPants.num,
          zindex: firstShirt.zindex,
        }
      });
    };
    const imageShirt = new window.Image();
    const firstShirt = shirt[Math.floor(Math.random() * shirt.length)];
    imageShirt.src = firstShirt.url;
    imageShirt.onload = () => {
      this.setState({
        shirt: {
          src: imageShirt,
          num: firstShirt.num,
          zindex: firstShirt.zindex,
        }
      });
    };
    const randomForHeadsAndFaces = Math.floor(Math.random() * heads.length);
    const imageHeads = new window.Image();
    const firstHeads = heads[randomForHeadsAndFaces];
    imageHeads.src = firstHeads.url;
    imageHeads.onload = () => {
      this.setState({
        heads: {
          src: imageHeads,
          num: firstHeads.num,
        }
      });
    };
    const imageFaces = new window.Image();
    const firstFaces = faces[randomForHeadsAndFaces];
    imageFaces.src = firstFaces.url;
    imageFaces.onload = () => {
      this.setState({
        faces: {
          src: imageFaces,
          num: firstFaces.num,
        }
      });
    };
    const imageAccessorius = new window.Image();
    const firstAccessorius = accessorius[Math.floor(Math.random() * accessorius.length)];
    imageAccessorius.src = firstAccessorius.url;
    imageAccessorius.onload = () => {
      this.setState({
        accessorius: {
          src: imageAccessorius,
          num: firstAccessorius.num,
        }
      });
    };

    for (let i = 0; i < 3; i++) {
      this.addText(
        true,
        0,
        this.state.width/2-60,
        (i+1) * 0.25 * this.state.height,
        300,
        50,
        '#333',
        fonts[0],
        false,
        false,
        false,
        22+(i*5),
        `Текст ${this.textCounter()}`
      );
    }
  }

  componentDidUpdate() {

  }

  increaseIndex = () => {
    this.setState({
      elementsIndex: this.state.elementsIndex + 1
    })
    // console.log(this.state.elementsIndex);
  };

  toggleControls = () => {
    this.setState(prevState => {
      return {showControls: !prevState.showControls}
    })
  };

  openControls = () => {
    this.setState({
      showControls: true
    })
  };

  togglePhotoAndBG = () => {
    this.setState({
      photoHidden: !this.state.photoHidden,
    })
  };

  onInputChange = (e, prop) => {
    this.setState({[prop]: e.target.value})
  };

  onInputCheck = (e, prop) => {
    this.setState(prevState => ({[prop]: !prevState[prop]}))
  };

  setInitialPosition = (x, y, prop) => {
    this.setState({[prop]: {x, y}})
  };

  // chooseNextBackground = () => {
  //   const bckgrndImg = new window.Image();
  //   bckgrndImg.src = backgrounds[this.currentBackground + 1] ? backgrounds[this.currentBackground + 1] : backgrounds[0];
  //   bckgrndImg.onload = () => {
  //     this.stage.getStage().findOne(".background").getImage().src = bckgrndImg.src;
  //     this.stage.getStage().findOne(".background").getLayer().batchDraw();
  //     this.currentBackground = (this.currentBackground + 1) < backgrounds.length ? this.currentBackground + 1 : 0;
  //   };
  // };
  //
  // choosePrevBackground = () => {
  //   const bckgrndImg = new window.Image();
  //   bckgrndImg.src = backgrounds[this.currentBackground - 1] ? backgrounds[this.currentBackground - 1] : backgrounds[backgrounds.length - 1];
  //   bckgrndImg.onload = () => {
  //     this.stage.getStage().findOne(".background").getImage().src = bckgrndImg.src;
  //     this.stage.getStage().findOne(".background").getLayer().batchDraw();
  //     this.currentBackground = (this.currentBackground - 1) > -1 ? this.currentBackground - 1 : backgrounds.length - 1;
  //   };
  // };
  //
  // chooseRandBackground = () => {
  //   const bckgrndImg = new window.Image();
  //   const randBcgr = Math.floor(Math.random() * backgrounds.length);
  //   bckgrndImg.src = backgrounds[randBcgr];
  //   bckgrndImg.onload = () => {
  //     console.log(this.stage.getStage().findOne(".background").getImage());
  //     this.stage.getStage().findOne(".background").getImage().src = bckgrndImg.src;
  //     this.stage.getStage().findOne(".background").getLayer().batchDraw();
  //     this.currentBackground = randBcgr;
  //   };
  // };

  chooseClothes = (e) => {
    const direction = e.target.dataset.direction;
    const clothing = e.target.dataset.clothing;
    const newImage = new window.Image();
    const newFace = new window.Image();
    let cloth;
    let face;
    let randNumb;
    let manyClothes = [];
    if (direction === "next") {
      if (clothing === "shoes") {
        cloth = shoes[this.currentShoes + 1] ? shoes[this.currentShoes + 1] : shoes[0];
      } else if (clothing === "pants") {
        cloth = pants[this.currentPants + 1] ? pants[this.currentPants + 1] : pants[0];
      } else if (clothing === "shirt") {
        cloth = shirt[this.currentShirt + 1] ? shirt[this.currentShirt + 1] : shirt[0];
      } else if (clothing === "heads") {
        cloth = heads[this.currentHeads + 1] ? heads[this.currentHeads + 1] : heads[0];
        face = faces[this.currentHeads + 1] ? faces[this.currentHeads + 1] : faces[0];
      } else if (clothing === "accessorius") {
        cloth = accessorius[this.currentAccessorius + 1] ? accessorius[this.currentAccessorius + 1] : accessorius[0];
      }
    } else if (direction === "prev") {
      if (clothing === "shoes") {
        cloth = shoes[this.currentShoes - 1] ? shoes[this.currentShoes - 1] : shoes[shoes.length - 1];
      } else if (clothing === "pants") {
        cloth = pants[this.currentPants - 1] ? pants[this.currentPants - 1] : pants[pants.length - 1];
      } else if (clothing === "shirt") {
        cloth = shirt[this.currentShirt - 1] ? shirt[this.currentShirt - 1] : shirt[shirt.length - 1];
      } else if (clothing === "heads") {
        cloth = heads[this.currentHeads - 1] ? heads[this.currentHeads - 1] : heads[heads.length - 1];
        face = faces[this.currentHeads - 1] ? faces[this.currentHeads - 1] : faces[faces.length - 1];
      } else if (clothing === "accessorius") {
        cloth = accessorius[this.currentAccessorius - 1] ? accessorius[this.currentAccessorius - 1] : accessorius[accessorius.length - 1];
      }
    } else if (direction === "rand") {
      if (clothing === "shoes") {
        cloth = shoes[Math.floor(Math.random() * shoes.length)];
      } else if (clothing === "pants") {
        cloth = pants[Math.floor(Math.random() * pants.length)];
      } else if (clothing === "shirt") {
        cloth = shirt[Math.floor(Math.random() * shirt.length)];
      } else if (clothing === "heads") {
        randNumb = Math.floor(Math.random() * heads.length);
        cloth = heads[randNumb];
        face = faces[randNumb];
      } else if (clothing === "accessorius") {
        cloth = accessorius[Math.floor(Math.random() * accessorius.length)];
      } else if (clothing === "every") {
        randNumb = Math.floor(Math.random() * heads.length);
        manyClothes.push({
          item: shoes[Math.floor(Math.random() * shoes.length)],
          name: 'shoes',
        });
        manyClothes.push({
          item: pants[Math.floor(Math.random() * pants.length)],
          name: 'pants',
        });
        manyClothes.push({
          item: shirt[Math.floor(Math.random() * shirt.length)],
          name: 'shirt',
        });
        manyClothes.push({
          item: heads[randNumb],
          name: 'heads',
        });
        manyClothes.push({
          item: faces[randNumb],
          name: 'faces',
        });
        manyClothes.push({
          item: accessorius[Math.floor(Math.random() * accessorius.length)],
          name: 'accessorius',
        });
      }
    }

    if (manyClothes.length) {
      const images = [];
      manyClothes.forEach((el, i) => {
        images.push(new window.Image());
        images[i].src = el.item.url;
        images[i].onload = () => {
          this.stage.getStage().findOne(`.${el.name}`).getImage().src = images[i].src;
          this.stage.getStage().findOne(`.${el.name}`).getLayer().batchDraw();
          if (el.name === "shoes") {
            this.currentShoes = el.item.num;
          } else if (clothing === "pants") {
            this.currentPants = el.item.num;
          } else if (clothing === "shirt") {
            this.currentShirt = el.item.num;
          } else if (clothing === "heads") {
            this.currentHeads = el.item.num;
          } else if (clothing === "accessorius") {
            this.currentAccessorius = el.item.num;
          }
        }
      })
    } else {
      if (face) {
        newFace.src = face.url;
        newFace.onload = () => {
          this.stage.getStage().findOne('.faces').getImage().src = newFace.src;
          this.stage.getStage().findOne('.faces').getLayer().batchDraw();
          this.currentFaces = cloth.num;
        }
      }
      newImage.src = cloth.url;
      newImage.onload = () => {
        this.stage.getStage().findOne(`.${clothing}`).getImage().src = newImage.src;
        this.stage.getStage().findOne(`.${clothing}`).getLayer().batchDraw();
        if (clothing === "shoes") {
          this.currentShoes = cloth.num;
        } else if (clothing === "pants") {
          this.currentPants = cloth.num;
        } else if (clothing === "shirt") {
          this.currentShirt = cloth.num;
        } else if (clothing === "heads") {
          this.currentHeads = cloth.num;
          this.currentFaces = face.num;
        } else if (clothing === "accessorius") {
          this.currentAccessorius = cloth.num;
        }
      };
    }
  };

  onFileInputChange = (e) => {
    const newAvatar = new window.Image();
    //newAvatar.setAttribute('crossOrigin', 'anonymous');
    newAvatar.onload = () => {
      // console.log(newAvatar.width);
      // console.log(newAvatar.height);
      let width = newAvatar.width;
      let height = newAvatar.height;
      if (width > height) {
        const k = width/height;
        if (width >= window.innerWidth/2) {
          width = window.innerWidth/2;
          height = width/k;
        }
        newAvatar.width = width;
        newAvatar.height = height;
      } else {
        const k = height/width;
        if (height >= window.innerHeight/2) {
          height = window.innerHeight/2;
          width = height/k;
        }
        newAvatar.width = width;
        newAvatar.height = height;
      }
      this.stage.getStage().findOne(".avatar").getImage().src = newAvatar.src;
      this.stage.getStage().findOne(".avatar").getLayer().batchDraw();
      this.setState({
        sideHeight: newAvatar.height,
        sideWidth: newAvatar.width,
        firstScreenShown: false,
      });
    };
    newAvatar.src = window.URL.createObjectURL(e.target.files[0]);
  };

  disableTransform = () => {
    let transformArray = [];
    transformArray.push(this.stage.getStage().findOne(".avatar-transform"));
    transformArray.push(this.stage.getStage().find(".newTexts-tranformer"));
    this.stage.getStage().find("Transformer").forEach((transformer) => {
      if (~transformer.name().indexOf('gift-transform')) {
        transformArray.push(transformer);
      }
    });
    // this.setState({
    //   showDeleteButton: false,
    // })
    transformArray.push(this.stage.getStage().find(".gift-transform"));
    transformArray.forEach(item => item.resizeEnabled(false).rotateEnabled(false).borderEnabled(false).forceUpdate());
    transformArray[0].getLayer().batchDraw();
    this.stage.getStage().find(node => {
      return node.getName() === 'text1-zoomer' || node.getName() === 'text2-zoomer' || node.getName() === 'text3-zoomer'
    }).forEach(zoomer => zoomer.hide());
    const imagesColletion = this.stage.getStage().find('.deleteButton');
    for (let i = 0; i < imagesColletion.length; i++) {
      imagesColletion[i].setAttr('visible', false);
    }
  };

  enableTransform = (elem) => {
    if (~elem.name().indexOf('text')){
      elem.parent.findOne('Transformer').borderEnabled(true).rotateEnabled(true);
      elem.parent.findOne('Transformer').getLayer().batchDraw();
      elem.parent.findOne('Transformer').forceUpdate();
      elem.parent.findOne('.deleteButton').setAttr('visible', true);
      let array = elem.parent.findOne('Transformer').find('Shape');
      array.forEach((sh) => {
        sh.attrs.stroke = "#fff";
        sh.attrs.strokeWidth = '2';
        sh.attrs.dash = [5,2];
      })
    } else if (~elem.name().indexOf('gift')){
      elem.parent.findOne('.deleteButton').setAttr('visible', true);
      // this.setState({
      //   showDeleteButton: true,
      // })
      // console.log(elem.parent.findOne('.deleteButton').attrs.visible);
      // elem.parent.findOne('.deleteButton').forceUpdate();
      elem.parent.findOne('Transformer').rotateEnabled(true).borderEnabled(true).resizeEnabled(true);
      elem.parent.findOne('Transformer').getLayer().batchDraw();
      elem.parent.findOne('Transformer').forceUpdate();
    }
  };

  toggleShowPalette = () => {
    this.setState(prevState => ({
        showPalette: !prevState.showPalette
      })
    )
  };

  toggleShowGiftPalette = () => {
    this.setState(prevState => ({
      showGiftPalette: !prevState.showGiftPalette
      })
    )
  };

  showCloseGiftPalette = (show) => {
    this.setState({
      showGiftPalette: show
    })
  };

  chooseTextColor = (e) => {
    this.setState({textColor: e.target.id})
  };

  onStageClick = (e) => {
    // console.log(e.target.name());
    if (e.target.name() === 'bg'
      || e.target.name() === 'shoes'
      || e.target.name() === 'pants'
      || e.target.name() === 'shirt'
      || e.target.name() === 'heads'
      || e.target.name() === 'accessorius'
      || e.target.name() === 'faces'
    ) {
      this.disableTransform();
      this.setPropsToAside(null);
      this.showCloseGiftPalette(false);
      this.setState({
        avatarZIndex: 10,
        // photoHidden: false,
      });
    } else if (~e.target.name().indexOf('text')) {
      this.disableTransform();
      this.enableTransform(e.target);
      this.setPropsToAside(e.target);
      this.openControls();
      this.setState({
        avatarZIndex: 10,
        // photoHidden: false,
      });
    } else if (~e.target.name().indexOf('gift')) {
      this.disableTransform();
      this.setPropsToAside(null);
      this.showCloseGiftPalette(false);
      this.setState({
        avatarZIndex: 10,
        // photoHidden: false,
      });
      this.enableTransform(e.target);
    } else if (~e.target.name().indexOf('avatar')) {
      this.setState({
        avatarZIndex: 1000,
      });
    }
  };

  randomize = (e) => {
    // this.chooseRandBackground();
    let texts = this.state.texts;
    texts.forEach(text => {
      text.color = `#${Math.floor(Math.random()*16777215).toString(16)}`;
      text.family = fonts[Math.floor(Math.random()*fonts.length)];
      text.italic = Math.round(Math.random());
      text.bold = Math.round(Math.random());
      text.underline = Math.round(Math.random());
      text.size = Math.floor(Math.random() * 22 + 20);
    });
    this.chooseClothes(e);
    this.setState({
      texts: Object.assign(this.state.texts, texts)
    })
  };

  addShape = (e, sType) => {
    let newCustomShapes = this.state.customShapes;
    newCustomShapes.push({type: sType});
    this.increaseIndex();
    this.setState({
      customShapes: newCustomShapes,
    })
  };

  addGift = (e,
             name,
             x = this.state.width/2 - 225 + Math.floor(Math.random()*200),
             y = this.state.height/1.6 - 225 + Math.floor(Math.random()*200),
             side = 125) => {
    let gifts = this.state.gifts;
    let image = new window.Image();
    gifts.forEach(g => {
      if (g.name === name) {
        image.src = g.url;
      }
    });
    switch (name) {
      case 'grena':
        x = 50;
        y = 50;
        break;
      case 'skull':
        x = 100;
        y = 100;
        break;
      default:
        break;
    }
    gifts.push({name: name, x: x, y: y, side: side, image: image});
    this.showCloseGiftPalette(false);
    this.increaseIndex();
    this.setState({
      gifts: gifts
    })
  };

  makeCounter = () => {
    let count = 1;
    return () => {
      return count++;
    }
  };

  textCounter = this.makeCounter();

  setGiftInitialPosition = (x, y, giftNum, group) => {
    // if (x + group.props.side/2 >= this.state.carX && y + group.props.side/2 >= this.state.carY) {
    //   if (group.transform.parent.findOne('Image')) {
    //     group.transform.parent.findOne('Image').destroy();
    //   }
    //   group.transform.rotateEnabled(false);
    //   group.transform.borderEnabled(false);
    //   group.transform.resizeEnabled(false);
    // }
    const currentGifts = this.state.gifts;
    currentGifts[giftNum].x = x;
    currentGifts[giftNum].y = y;
    const visibility = group.transform.parent.findOne('.deleteButton').getAttr('visible');
    this.setState({
      gifts: currentGifts
    });
    group.transform.parent.findOne('.deleteButton').setAttr('visible', visibility);
  };

  setTextInitialPosition = (x, y, textNum, group) => {
    // if (x + group.transform.parent.findOne('Text').textWidth/2 >= this.state.carX && y + group.transform.parent.findOne('Text').textHeight/2 >= this.state.carY) {
    //   group.transform.parent.findOne('Text').remove();
    //   group.transform.rotateEnabled(false);
    //   group.transform.borderEnabled(false);
    //   this.setState({
    //     currentTextSet: {
    //       color: '',
    //       family: '',
    //       italic: false,
    //       bold: false,
    //       underline: false,
    //       size: '',
    //       value: '',
    //       unit: null,
    //     }
    //   })
    // } else {}
    const currentTexts = this.state.texts;
    currentTexts[textNum].x = x;
    currentTexts[textNum].y = y;
    // console.log(this.state.showDeleteButton)
    // console.log(group.transform.parent.findOne('.deleteButton').getAttr('visible'));
    const visibility = group.transform.parent.findOne('.deleteButton').getAttr('visible');
    this.setState({
      texts: currentTexts,
    });
    group.transform.parent.findOne('.deleteButton').setAttr('visible', visibility);

    // elem.parent.findOne('.deleteButton').setAttr('visible', true);
  };

  addText = (e,
             i = 0,
             x = Math.floor(Math.random()*(this.state.width*0.7) + this.state.width*0.15),
             y = Math.floor(Math.random()*(this.state.height*0.7) + this.state.height*0.15),
             width = 300,
             height = 50,
             color = '#333',
             family = fonts[0],
             italic = false,
             bold = false,
             underline = false,
             size = 22,
             value = `Текст ${this.textCounter()}`) => {
    const currentTexts = this.state.texts;
    currentTexts.push({
      x: x,
      y: y,
      width: width,
      height: height,
      color: color,
      family: family,
      italic: italic,
      bold: bold,
      underline: underline,
      size: size,
      value: value,
    });
    this.increaseIndex();
    this.setState({
      texts: currentTexts
    })
  };


  setPropsToAside = (text) => {
    if (text !== null) {
      let isBold, isItalic, isUnderline;

      if (~text.attrs.fontStyle.indexOf('bold')) {
        isBold = true;
      } else {
        isBold = false;
      }

      if (~text.attrs.fontStyle.indexOf('italic')) {
        isItalic = true;
      } else {
        isItalic = false;
      }

      if (~text.attrs.textDecoration.indexOf('underline')) {
        isUnderline = true;
      } else {
        isUnderline = false;
      }
      this.setState({
        currentTextSet: {
          color: text.attrs.fill,
          family: text.attrs.fontFamily,
          italic: isItalic,
          bold: isBold,
          underline: isUnderline,
          size: text.attrs.fontSize,
          value: text.attrs.text,
          unit: text.attrs.id >= 0 ? text.attrs.id : 0,
        }
      })
    } else {
      this.setState({
        currentTextSet: {
          color: '',
          family: '',
          italic: false,
          bold: false,
          underline: false,
          size: '',
          value: '',
          unit: null,
        }
      })
    }
  };

  sendToServer = () => {
    this.disableTransform();

    const dataURItoBlob = (uri) => {
      let binary = atob(uri.split(',')[1]);
      let array = [];
      for(let i = 0; i < binary.length; i++) {
        array.push(binary.charCodeAt(i));
      }
      console.log('new blob');
      console.log(new Blob([new Uint8Array(array)], {type: 'image/png'}));
      return new Blob([new Uint8Array(array)], {type: 'image/png'});
    };

    const makeRequest = (token, blob) => {
      const formData = new FormData();
      formData.append('form[file]', blob, 'capsulechix.png');
      formData.append('form[_token]', token);
      const serverName = 'www.karusel-tv.ru';
      fetch(`https://${serverName}/uploader/image.json`, {
        method: "POST",
        mode: 'cors',
        credentials: 'include',
        body: formData,
      })
        .then(response => response.json())
        .then((result) => {
          console.log(result);
          const bt = btoa(result.file.name);
          window.top.location.href = (`https://${serverName}/contest/CapsuleChix?pc=${bt}`);
        })
        .catch(error => console.error(error));
    };

    console.log('token');
    console.log(this.state.token);
    if (this.state.token) {
      let dataURL = this.stage.getStage().toDataURL();
      let blob = dataURItoBlob(dataURL);
      makeRequest(this.state.token, blob);
    }
  };

  saveStage = () => {
    this.disableTransform();
    this.hideCar();
    let downloadURI = (uri, name) => {
      if (window.navigator.msSaveBlob) {
        let dataURItoBlob = (uri) => {
          var binary = atob(uri.split(',')[1]);
          var array = [];
          for(var i = 0; i < binary.length; i++) {
            array.push(binary.charCodeAt(i));
          }
          return new Blob([new Uint8Array(array)], {type: 'image/png'});
        };
        var blob = dataURItoBlob(uri);
        window.navigator.msSaveOrOpenBlob(blob, "capsulechix.png");
      } else {
        var link = document.createElement("a");
        link.download = name;
        link.href = uri;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    };
    // setTimeout, чтобы конва успела удалить рамки, если пользователь этого не сделал, и перерисоваться
    setTimeout(()=> {
      let dataURL = this.stage.getStage().toDataURL();
      downloadURI(dataURL, 'capsulechix.png');
      this.showCar();
    },400);
  };

  changeFontColor = (color, prop) => {
    this.setState({
      currentTextSet: Object.assign(this.state.currentTextSet,{[prop]: color})
    })
  };

  changeFontSize = (expand, size) => {
    let newTextSet = Object.assign({},this.state.currentTextSet);
    expand ? newTextSet[size]++ : newTextSet[size]--;
    this.setState({
      currentTextSet: Object.assign(this.state.currentTextSet,{[size]: newTextSet[size]})
    })
  };

  changeFontFamily = (next, prop) => {
    let index;
    fonts.forEach((font, i) => {
      if (this.state.currentTextSet.family === font) {
        index = i;
      }
    });
    if (!next) {
      fonts[index - 1] ? index-=1 : index = fonts.length - 1;
    } else {
      fonts[index + 1] ? index+=1 : index = 0;
    }
    this.setState({
      currentTextSet: Object.assign(this.state.currentTextSet, {[prop]: fonts[index]})
    })
  };

  findTextAndSetProps = (e, prop) => {
    switch (prop) {
      case "value":
        this.onChangeCurrentText(e.target.value, prop);
        break;
      case "size":
        this.changeFontSize(e, prop);
        break;
      case "color":
        this.changeFontColor(e.target.id, prop);
        break;
      case "family":
        this.changeFontFamily(e, prop);
        break;
      case "italic":
        this.toggleStyle(prop);
        break;
      case "bold":
        this.toggleStyle(prop);
        break;
      case "underline":
        this.toggleStyle(prop);
        break;
      default:
        break;
    }
    let allTexts = this.state.texts;
    for (let i = 0; i < allTexts.length; i++) {
      if (i === this.state.currentTextSet.unit) {
        allTexts[i] = Object.assign(allTexts[i], this.state.currentTextSet)
      }
    }
    this.setState({
      texts: allTexts
    });
    if (this.stage.getStage().findOne(`#${this.state.currentTextSet.unit}`)){
      this.enableTransform(this.stage.getStage().findOne(`#${this.state.currentTextSet.unit}`))
    }
  };

  onChangeCurrentText = (val, prop) => {
    let newCurrentTextSet = Object.assign({},this.state.currentTextSet);
    newCurrentTextSet[prop] = val;
    if (prop === "value"){
      this.setState({
        currentTextSet: Object.assign(this.state.currentTextSet,{[prop]: val})
      })
    }
  };

  toggleStyle = (prop) => {
    this.setState({
      currentTextSet: Object.assign(this.state.currentTextSet, {[prop]: !this.state.currentTextSet[prop]})
    })
  };

  deleteElement = (elem) => {
    const type = elem.__proto__.constructor.name.toLowerCase();
    if (type === 'gift') {
      if (elem.transform.parent.findOne('Image')) {
        elem.transform.parent.findOne('Image').destroy();
        elem.transform.parent.findOne('.deleteButton').destroy();
      }
      elem.transform.rotateEnabled(false);
      elem.transform.borderEnabled(false);
      elem.transform.resizeEnabled(false);
      const newgifts = Array.from(this.state.gifts);
      for (let i = 0; i < newgifts.length; i++) {
        if (elem.props.i === newgifts[i]) {
          newgifts[i] = null;
        }
      }
      this.setState({
        gifts: newgifts,
      })
    } else if (type === 'textsolo') {
      elem.transform.parent.remove();
      elem.transform.rotateEnabled(false);
      elem.transform.borderEnabled(false);
      this.setState({
        currentTextSet: {
          color: '',
          family: '',
          italic: false,
          bold: false,
          underline: false,
          size: '',
          value: '',
          unit: null,
        }
      })
    } else if (type === 'avatargroup') {
      // console.log('this is an avatar');
    }
  };

  hideCar = () => {
      this.setState({
        carOpacity: 0
      })
  };

  showCar = () => {
    this.setState({
      carOpacity: 1
    })
  };

  hideFirstScreen = (e) => {
    this.setState({
      firstScreenShown: false
    });
  };

  render() {
    return (
      <div className={classes.Main}>
        <Stage
          width={this.state.width}
          height={this.state.width}
          ref={node => {
            this.stage = node;
          }}
          className={classes.Stage}
          onClick={e => this.onStageClick(e)}
          onTap={e => this.onStageClick(e)}
        >
          <Layer>
            {/*<Image*/}
            {/*  name="background"*/}
            {/*  image={this.state.background}*/}
            {/*  width={this.state.width}*/}
            {/*  height={this.state.height}*/}
            {/*  zIndex={0}*/}
            {/*  globalCompositeOperation="source-over"*/}
            {/*/>*/}
            <Image
              name="bg"
              image={this.state.bg}
              width={this.state.width}
              height={this.state.height}
              zIndex={1}
              globalCompositeOperation="source-over"
            />
            <Image
              name="body"
              image={this.state.body}
              width={this.state.width}
              height={this.state.height}
              zIndex={1}
              globalCompositeOperation="source-over"
            />
            <Image
              name="shoes"
              image={this.state.shoes.src}
              width={this.state.width}
              height={this.state.height}
              zIndex={3}
              globalCompositeOperation="source-over"
            />
            <Image
              name="pants"
              image={this.state.pants.src}
              width={this.state.width}
              height={this.state.height}
              globalCompositeOperation="source-over"
              zIndex={2}
            />
            <Image
              name="shirt"
              image={this.state.shirt.src}
              width={this.state.width}
              height={this.state.height}
              globalCompositeOperation="source-over"
              zIndex={4}
            />
            <Image
              name="faces"
              image={this.state.faces.src}
              width={this.state.width}
              height={this.state.height}
              zIndex={5}
              globalCompositeOperation="destination-out"
            />
            <Image
              name="heads"
              image={this.state.heads.src}
              width={this.state.width}
              height={this.state.height}
              zIndex={5}
              globalCompositeOperation="source-over"
            />
            <Image
              name="accessorius"
              image={this.state.accessorius.src}
              width={this.state.width}
              height={this.state.height}
              zIndex={10}
              globalCompositeOperation="source-over"
            />
            <AvatarGroup
              x={this.state.avatarPosition ? this.state.avatarPosition.x : this.state.width/2 - this.state.imgSide/2}
              y={this.state.avatarPosition ? this.state.avatarPosition.y : this.state.height/4.5 - this.state.imgSide/2}
              sideHeight={this.state.sideHeight}
              sideWidth={this.state.sideWidth}
              zIndex={this.state.avatarZIndex}
              setInitialPosition={this.setInitialPosition}
              zoomerSide={this.state.zoomerSide}
              deleteElement={this.deleteElement}
              // globalCompositeOperation={this.state.photoHidden ? "destination-over" : "source-over"}
              globalCompositeOperation='destination-over'
            />
            {this.state.gifts.length>0 && this.state.gifts.map((gift, i) => {
              return (
                <Gift
                  key={`gift-${i}`}
                  gift={gift}
                  i={i}
                  x={gift.x}
                  y={gift.y}
                  side={gift.side}
                  image={gift.image}
                  setGiftInitialPosition={this.setGiftInitialPosition}
                  zIndex={2}
                  deleteElement={this.deleteElement}
                  // dbVisible={this.state.showDeleteButton}
                />
              )
            })
            }
            {/*{this.state.texts.length>0 && this.state.texts.map((text, i) => {*/}
            {/*  return (*/}
            {/*    <TextSolo*/}
            {/*      key={`text-${i}`}*/}
            {/*      name={`text-${i}`}*/}
            {/*      i={i}*/}
            {/*      x={text.x}*/}
            {/*      y={text.y}*/}
            {/*      width={text.width}*/}
            {/*      height={text.height}*/}
            {/*      color={text.color}*/}
            {/*      family={text.family}*/}
            {/*      italic={text.italic}*/}
            {/*      bold={text.bold}*/}
            {/*      underline={text.underline}*/}
            {/*      size={text.size}*/}
            {/*      value={text.value}*/}
            {/*      setTextInitialPosition={this.setTextInitialPosition}*/}
            {/*      carX={this.state.carX}*/}
            {/*      carY={this.state.carY}*/}
            {/*      deleteElement={this.deleteElement}*/}
            {/*      zIndex={9}*/}
            {/*    />*/}
            {/*  )*/}
            {/*})*/}
            {/*}*/}
          </Layer>

        </Stage>
        <Controls
          open={this.state.showControls}
          toggleControls={this.toggleControls}
          palette={palette}
          showPalette={this.state.showPalette}
          toggleShowPalette={this.toggleShowPalette}
          textColor={this.state.textColor}
          chooseTextColor={this.chooseTextColor}
          onFileInputChange={this.onFileInputChange}
          onInputChange={this.onInputChange}
          onInputCheck={this.onInputCheck}
          // chooseNextBackground={this.chooseNextBackground}
          // choosePrevBackground={this.choosePrevBackground}
          // chooseShoes={this.chooseShoes}
          // choosePants={this.choosePants}
          // chooseShirt={this.chooseShirt}
          // chooseHeads={this.chooseHeads}
          chooseClothes={this.chooseClothes}
          onStageSave={this.saveStage}
          sendToServer={this.sendToServer}
          randomize={this.randomize}
          addShape={this.addShape}
          addGift={this.addGift}
          showGiftPalette={this.state.showGiftPalette}
          toggleShowGiftPalette={this.toggleShowGiftPalette}
          gifts={gifts}
          addText={this.addText}
          currentTextSet={this.state.currentTextSet}
          findTextAndSetProps={this.findTextAndSetProps}
          changeFontSize={this.changeFontSize}
          italic={this.state.currentTextSet.italic}
          bold={this.state.currentTextSet.bold}
          underline={this.state.currentTextSet.underline}
          onClick={this.disableTransform}
          togglePhotoAndBG={this.togglePhotoAndBG}
          photoHidden={this.state.photoHidden}
          token={this.state.token}
        />
        <ControlsToggle click={this.toggleControls}/>
        <FirstScreen
          isShown={this.state.firstScreenShown}
          onFileInputChange={this.onFileInputChange}
        />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js